module.exports = __webpack_public_path__ + "img/TS6201-301.de014592.jpg";